import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  justifyContentSpaceAround,
  justifyContentSpaceBetween,
  layerC,
} from '../../styles/commonStyles';

import SegmentContent from '../masterControlAndOverSight/overSightHP/segment/segmentContent';
import OverSightTitleInfo from '../masterControlAndOverSight/overSightHP/titleInfo';
import { useState } from 'react';
import Zone from '../masterControlAndOverSight/overSightHP/zone';
import OverSightSubIndividualContentDisplayBox from './OverSightSubIndividualContentDisplayBox';

const OverSightIndividualContentDisplayBox = ({
  isMainTitle,
  openingId,
  title,
  consumption,
  usage,
  isOn,
  dataAccessKey,
}) => {
  const stationsData = {};

  const [trackSegmentOpening, setTrackSegmentOpening] = useState(false);

  const trackSegmentOpeningsHandler = () => {
    setTrackSegmentOpening((prev) => !prev);
  };

  return (
    <Wrapper isMainTitle={isMainTitle} isExpand={trackSegmentOpening}>
      <OverSightSubIndividualContentDisplayBox
        isMainTitle={isMainTitle}
        isSegment={true}
        title={title}
        consumption={consumption}
        usage={usage}
        isOn={isOn}
        trackOpeningsHandler={trackSegmentOpeningsHandler}
      />
      {trackSegmentOpening &&
        stationsData[dataAccessKey]?.[openingId]?.zones?.map((zoneData) => (
          <OverSightSubIndividualContentDisplayBox
            key={zoneData.id}
            id={zoneData.id}
            title={zoneData.name}
            consumption={zoneData.consumption}
            usage={zoneData.usage}
            isOn={zoneData.isOn}
            data={zoneData.sections}
            isZone={true}
          />
        ))}
      {/* {trackSegmentOpening &&
        segmentsData[openingId].zones.map((zoneData) => (
          <OverSightSubIndividualContentDisplayBox
            key={zoneData.id}
            id={zoneData.id}
            title={zoneData.name}
            consumption={zoneData.consumption}
            usage={zoneData.usage}
            isOn={zoneData.isOn}
            data={zoneData.sections}
            isZone={true}
          />
        ))} */}
    </Wrapper>
  );
};

export default OverSightIndividualContentDisplayBox;

{
  /* <>
  {zonesData[openingId].zones[trackZoneIdx].sections.map(
    (sectionData) => (
      <OverSightSubIndividualContentDisplayBox
        key={sectionData.id}
        title={sectionData.name}
        consumption={sectionData.consumption}
        usage={sectionData.usage}
        isOn={sectionData.isOn}
      />
    )
  )}
</>; */
}
const Wrapper = styled.div`
  ${({ isMainTitle }) =>
    isMainTitle
      ? css`
          height: 32px;
        `
      : css`
          height: 34px;
        `}

  width: 1152px;
  border-radius: 15px;
  ${layerC}
  /* background: #142033;
  box-shadow: inset 0px 0px 6px #000000; */

  ${flexBoxCenter}
  ${({ isExpand }) =>
    isExpand &&
    css`
      height: auto;
      flex-direction: column;
      gap: 2px;
      margin: 2px;
      padding: 2px;
    `}
`;
